import React from 'react';
import RawHtml from '../Editors/RawHtml/raw-html.jsx';

export const EduCourseDetail = ({ dataToRender }) => {
  return (
    <table className="table table-striped table-bordered">
      <tbody>
        {dataToRender.map(({ label, value, isRaw = false }) => {
          // Normalize: trim strings; leave other types as-is
          const normalizedValue =
            typeof value === 'string' ? value.trim() : value;
          const isEmpty =
            normalizedValue === '' ||
            normalizedValue === null ||
            normalizedValue === undefined;

          return (
            <tr key={label}>
              <td style={{ width: '25%' }}>
                <b>{label}</b>
              </td>
              <td>
                {isEmpty ? (
                  '-'
                ) : isRaw ? (
                  <RawHtml>{normalizedValue}</RawHtml>
                ) : (
                  normalizedValue
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
